module.exports = __webpack_public_path__ + "img/html.f3a041f1.svg";